import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { deliveryJoinPath, staffBrandKicker, staffBrandTitle } from "@/lib/teamHub";

const PINK = "#EE2677";

/** Shown after employee sign-up while manager reviews on M Team page. */
export default function TsPendingApproval({ employee, onRefresh, onReauth, busy = false }) {
  const name = (employee?.name || "").trim();

  return (
    <div className="ts-pending">
      <style>{`
        .ts-pending {
          min-height: 100dvh; background: #F5F2EA; color: #2D2D2D;
          padding: 24px 14px 32px; max-width: 480px; margin: 0 auto;
          font-family: system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;
          text-align: center;
        }
        .ts-pending * { box-sizing: border-box; }
        .ts-pending-kicker {
          font-size: 11px; font-weight: 800; letter-spacing: 0.12em;
          text-transform: uppercase; color: rgba(45,45,45,0.45); margin: 0 0 4px;
        }
        .ts-pending-title { font-size: 28px; font-weight: 900; color: ${PINK}; margin: 0 0 20px; }
        .ts-pending-card {
          background: #fff; border-radius: 20px; padding: 24px 18px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.06); text-align: left;
        }
        .ts-pending-card h2 { margin: 0 0 8px; font-size: 20px; font-weight: 800; }
        .ts-pending-card p {
          margin: 0 0 12px; font-size: 14px; line-height: 1.5; color: rgba(45,45,45,0.7);
        }
        .ts-pending-badge {
          display: inline-block; padding: 6px 12px; border-radius: 999px;
          background: #FEF3C7; color: #92400E; font-size: 12px; font-weight: 800;
          letter-spacing: 0.04em; text-transform: uppercase; margin-bottom: 12px;
        }
        .ts-pending-btn {
          width: 100%; border: none; border-radius: 16px; padding: 14px;
          font-size: 16px; font-weight: 800; color: #fff; background: ${PINK};
          cursor: pointer; margin-top: 8px;
        }
        .ts-pending-btn:disabled { opacity: 0.6; cursor: wait; }
        .ts-pending-link {
          display: block; width: 100%; margin-top: 10px; border: none; background: transparent;
          color: rgba(45,45,45,0.55); font-size: 14px; font-weight: 700; cursor: pointer; padding: 8px;
          text-decoration: none; text-align: center;
        }
        .ts-pending-rider {
          margin-top: 14px; padding: 12px 14px; border-radius: 14px;
          background: #FFF7ED; border: 1px solid #FDBA74;
          font-size: 13px; font-weight: 600; color: #9A3412; line-height: 1.45; text-align: center;
        }
        .ts-pending-rider a { color: #C2410C; font-weight: 800; }
      `}</style>

      <p className="ts-pending-kicker">{staffBrandKicker()}</p>
      <h1 className="ts-pending-title">{staffBrandTitle()}</h1>

      <div className="ts-pending-card">
        <span className="ts-pending-badge">Pending approval</span>
        <h2>{name ? `Hi ${name}` : "Access request sent"}</h2>
        <p>
          Your manager will review your profile on the Team page, assign your Employee ID, and choose
          which apps you can use (Kitchen, Delivery, Inventory, Chat, Work Ethic).
        </p>
        <p>Come back here after approval. You will only see the apps your manager grants.</p>
        <button type="button" className="ts-pending-btn" onClick={onRefresh} disabled={busy}>
          {busy ? <Loader2 className="animate-spin" size={18} style={{ verticalAlign: "middle" }} /> : null}
          {busy ? " Checking…" : "Check approval status"}
        </button>
        {onReauth ? (
          <button type="button" className="ts-pending-link" onClick={onReauth}>
            Verification expired? Sign in with SMS again
          </button>
        ) : null}
      </div>

      <p className="ts-pending-rider">
        Delivery rider by mistake?{" "}
        <Link to={deliveryJoinPath()}>Open the Delivery app</Link>
      </p>
    </div>
  );
}
